
<!-- Search and NEW -->
<div class="flexie-auto-grid p-b-20">
  <div>
    <h3>Search</h3>
    <!-- <app-ui-search [searchables]="['Policy Number','Intimation Number','Customer Name','Claimant Name','Claimant Telephone Number','Claimant Email']"></app-ui-search> -->
  </div>
  <div class="text-a-right">
    <button nz-button [nzType]="'primary'" (click)="newIntimation()"><i nz-icon nzType="plus"  nzTheme="outline"></i> New Intimation</button>
  </div>
</div>

<h3 class="heading">Last 5 Intimations</h3>

<!-- Data -->
<nz-table [nzData]="dataSet" [nzScroll]="{ x: '1500px' }">
  <thead>
  <tr>
    <th>Policy No</th>
    <th>Intimation No</th>
    <th>Customer Name</th>
    <th>Claimant Name</th>
    <th>Claimant Telephone No</th>
    <th>Claimant Email</th>
    <th>Intimation Date</th>
    <th>Intimation Status</th>
    <th>Event Type</th>
    <th>Event Date</th>
  </tr>
  </thead>
  <tbody>
  <tr>
    <td>P9200199/JMSP</td>
    <td><a routerLink="/app/claims/details/intimation/claims-life">I902028192</a></td>
    <td>Chris Hemsworth</td>
    <td>Liam Hemsworth</td>
    <td>9008902991</td>
    <td>liam@hemsworth.com</td>
    <td>10 May 2019</td>
    <td>Draft</td>
    <td>Death</td>
    <td>5 May 2019</td>
  </tr>
  <tr>
    <td>P9200199/JMSP/ADDON</td>
    <td><a routerLink="/app/claims/details/intimation/claims-life">I902028191</a></td>
    <td>Chris Hemsworth</td>
    <td>Luke Hemsworth</td>
    <td>8119028811</td>
    <td>luke007@hemsworth.com</td>
    <td>10 May 2019</td>
    <td>Draft</td>
    <td>Death</td>
    <td>5 May 2019</td>
  </tr>
  <tr>
    <td>P7800493/PCIU</td>
    <td><a routerLink="/app/claims/details/intimation/claims-life">I902029804</a></td>
    <td>Uma Thurman</td>
    <td>Thomas Thurman</td>
    <td>9008902991</td>
    <td>mr.thurman@gmail.com</td>
    <td>9 May 2019</td>
    <td>Draft</td>
    <td>Death</td>
    <td>1 May 2019</td>
  </tr>
  <tr>
    <td>P7700675/PCTY</td>
    <td><a routerLink="/app/claims/details/intimation/claims-life">I90202980</a></td>
    <td>Chris Pine</td>
    <td>Reeve Pine</td>
    <td>8997160611</td>
    <td>reeve@thepines.net</td>
    <td>9 May 2019</td>
    <td>Draft</td>
    <td>Death</td>
    <td>29 Apr 2019</td>
  </tr>
  <tr>
    <td>P6070467/PCTX</td>
    <td><a routerLink="/app/claims/details/intimation/claims-life">I902028763</a></td>
    <td>Timothy Olyphant</td>
    <td>Thomas Xavier</td>
    <td>9887661092</td>
    <td>tomas.009@megacorp.com</td>
    <td>8 May 2019</td>
    <td>Draft</td>
    <td>Death</td>
    <td>28 Apr 2019</td>
  </tr>
  </tbody>
</nz-table>

